export var collapsibleCardTheme = {
  baseStyle: {
    header: {
      color: 'neutral.black',
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer',
      padding: 'm',
      userSelect: 'none',
      '&[data-inactive="true"]': {
        opacity: '0.65',
        cursor: 'not-allowed'
      },
      _disabled: {
        color: 'neutral.light',
        cursor: 'not-allowed'
      }
    },
    customHeader: {
      width: '100%',
      _disabled: {
        opacity: '0.35'
      }
    },
    content: {
      padding: 'm',
      paddingTop: 'none',
      display: 'flex',
      flexDirection: 'column',
      gap: 'm',
      cursor: 'default'
    }
  }
};
//# sourceMappingURL=CollapsibleCard.theme.js.map